import * as tslib_1 from "tslib";
import { Getter, Mutation } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";
import { t } from "@/helpers/i18n";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.items = [
            {
                value: "inear",
                text: t("soundSource.options.inEar")
            },
            {
                value: "ambient",
                text: t("soundSource.options.ambient")
            }
        ];
    }
    get selected() {
        return this.items.find(v => v.value == this.selectedSource);
    }
    change(v) {
        this.setSource(v);
    }
};
tslib_1.__decorate([
    Getter("config/selectedSoundSource")
], widget.prototype, "selectedSource", void 0);
tslib_1.__decorate([
    Mutation("config/setSelectedTimeRange")
], widget.prototype, "setSource", void 0);
widget = tslib_1.__decorate([
    Component({})
], widget);
export default widget;
